import Extension from "../base/extension";

class MetaobjectUtilities extends Extension {
  constructor(name) {
    super(name);

    Stencil.registerHelper("getMetaobjects", this.#getMetaobjects, this);
  }

  async #getMetaobjects(type, sortField = 'handle') {
    const query = `
      query MetaobjectsQuery($after: String) {
        metaobjects(type: "${type}", first: 50, after: $after) {
          nodes {
            id
            handle
            fields {
              key
              value
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;
    let metaobjects = await Stencil.Helpers.getAllNodes(query);

    // Add a key-value map of fields to each metaobject
    const transformedMetaobjects = metaobjects.map(obj => ({
      ...obj,
      fields_keyed: obj.fields.reduce((acc, field) => {
        acc[field.key] = field.value;
        return acc;
      }, {})
    }));

    // Natural sort based on sortField
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    const sortedMetaobjects = transformedMetaobjects.sort((a, b) => 
      collator.compare(a.fields_keyed[sortField], b.fields_keyed[sortField])
    );

    return sortedMetaobjects;
  }
}

export default MetaobjectUtilities;